import { useState, useEffect } from 'react';
import { Warp } from '@paper-design/shaders-react';
import './App.css';

function App() {
  const [showHeader, setShowHeader] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const [dMovies, setDMovies] = useState(false);
  const [dMusic, setDMusic] = useState(false);
  const [dMagic, setDMagic] = useState(false);
  const [dMultiplied, setDMultiplied] = useState(false);

  const [mRevealed, setMRevealed] = useState([false, false, false, false]);

  useEffect(() => {
    const t = [];
    const s = (fn, ms) => { t.push(setTimeout(fn, ms)); };

    s(() => setShowHeader(true), 200);
    s(() => setDMovies(true), 500);
    s(() => setDMusic(true), 900);
    s(() => setDMagic(true), 1300);
    s(() => setDMultiplied(true), 1800);
    s(() => setShowButton(true), 2300);
    s(() => setShowFooter(true), 2700);

    [0, 1, 2, 3].forEach((i) => {
      s(() => setMRevealed((p) => { const n = [...p]; n[i] = true; return n; }), 500 + i * 350);
    });

    return () => t.forEach(clearTimeout);
  }, []);

  return (
    <div className="scene">
      {/* Warp shader background */}
      <div className="shader-bg">
        <Warp
          style={{ height: '100%', width: '100%' }}
          proportion={0.45}
          softness={1}
          distortion={0.2}
          swirl={0.6}
          swirlIterations={10}
          shape="checks"
          shapeScale={0.08}
          scale={1}
          rotation={0}
          speed={1.5}
          colors={[
            'hsl(4, 90%, 22%)',
            'hsl(4, 85%, 35%)',
            'hsl(10, 80%, 28%)',
            'hsl(4, 90%, 18%)',
          ]}
        />
      </div>

      <div className={`brand-header ${showHeader ? 'visible' : ''}`}>
        Elephanta Films
      </div>

      {/* ── DESKTOP ── */}
      <div className="desktop-layout">
        <div className="top-line">
          <span className={`tw ${dMovies ? 'visible' : ''}`}>Movies.&nbsp; </span>
          <span className={`tw ${dMusic ? 'visible' : ''}`}>Music.&nbsp; </span>
          <span className={`tw ${dMagic ? 'visible' : ''}`}>Magic.</span>
        </div>
        <div className={`big-word ${dMultiplied ? 'visible' : ''}`}>
          Multiplied
        </div>
      </div>

      {/* ── MOBILE ── */}
      <div className="mobile-layout">
        <div className={`m-word m-movies ${mRevealed[0] ? 'revealed' : ''}`}>Movies</div>
        <div className={`m-word m-music ${mRevealed[1] ? 'revealed' : ''}`}>Music</div>
        <div className={`m-word m-magic ${mRevealed[2] ? 'revealed' : ''}`}>Magic</div>
        <div className={`m-word m-multiplied ${mRevealed[3] ? 'revealed' : ''}`}>Multiplied</div>
      </div>

      <div className={`social-footer ${showFooter ? 'visible' : ''}`}>
        <a href="https://www.instagram.com/elephantafilms/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" />
            <circle cx="12" cy="12" r="5" />
            <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
          </svg>
        </a>
        <a href="https://www.youtube.com/@Elephantafilms" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        </a>
      </div>
    </div>
  );
}

export default App;
